export default __webpack_public_path__ + "static/media/2k_earth_daymap.981cc3e3.jpg";